import { Inject } from '@odinjs/odin';

import { Endpoint } from '@philips-emr/hpms-provider-commons';
import TermsService from '@philips-emr/hpms-provider-commons/lib/services/terms-service';
import { HpmsTextHtmlAPI } from '@philips-emr/hpms-provider-components';
import { ToastNotificationAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnCancel, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { AuthenticationService, HttpService, ModalService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames } from '../codegen';
import { AssingTermAliases } from '../codegen/constants/aliases/assing-term-aliases';
import { FOUNDATION_ROUTES } from '../route';

import BaseController from './BaseController';

interface Term {
  dsTerm: string,
  nrSequence: number,
}

@Controller({ fragment: FragmentNames.ASSING_TERM })
export default class AssingTermControler extends BaseController {

  @Inject(AssingTermAliases.HPMS_TEXT_HTML_0)
  private textHtml: HpmsTextHtmlAPI;
  @Inject(AssingTermAliases.TOAST_NOTIFICATION)
  private toast: ToastNotificationAPI;

  @OnAfterFetch(AssingTermAliases.FETCH_0)
  onMountTermoTexto(event: FetchEvent): void {
    const { dsTerm } = event.data as Term;
    this.textHtml.setData(dsTerm);
  }

  @OnSubmit(AssingTermAliases.FORM_TERM)
  onSubmitTerm(event: SubmitEvent): void {
    const { record } = event;
    if (!record || !record.checked) {
      this.toast.setVisible(true);
      this.scrollDownPanelTerm();
      return;
    }

    void HttpService.post(Endpoint.POST.TERMS, {}, { body: record }).then(() => {
      ModalService.close('term-modal');
      TermsService.checkTerms();
    });
  }

  @OnCancel(AssingTermAliases.FORM_TERM)
  onclose(): void {
    void AuthenticationService.logout().then(() => {
      this.historyService.push(FOUNDATION_ROUTES.LOGIN);
    });
  }

  scrollDownPanelTerm(): void {
    const termPanel = document.querySelector<HTMLDivElement>('.c-modal__content--with-stack-manager');
    if (termPanel) {
      const { scrollHeight } = termPanel;
      termPanel.scrollTo({ top: scrollHeight, behavior: 'smooth' });
    }
  }
}
